module.exports = __webpack_public_path__ + "d8e7006d62eeebed5d5296e3295f8ad5.png";